import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { URLS } from "@shared-config/urls";
import { Workflow } from "@shared-interfaces/shared-workflow";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class WorkflowService {
  private httpClient = inject(HttpClient);

  createNewWorkflow(workflowName: string, workflowType: string): Observable<Workflow> {
    return this.httpClient.post<Workflow>(`${URLS.CONTENT_COLLECTION}/contract`, { name: workflowName, workflow_type: workflowType });
  }

  createPromptTesting(workflowName: string): Observable<Workflow> {
    return this.httpClient.post<Workflow>(`${URLS.CONTENT_COLLECTION}/prompt_testing`, { name: workflowName });
  }

  getWorkflow(workflowId: string): Observable<Workflow | undefined> {
    return this.httpClient.get<Workflow | undefined>(
      `${URLS.CONTENT_COLLECTION}/${workflowId}`
    );
  }

  storeWorkflow(
    workflowId: string | undefined,
    workflow_data: Workflow | undefined
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${URLS.CONTENT_COLLECTION}/${workflowId}`,
      workflow_data
    );
  }

  deleteWorkflow(workflowId: string): Observable<any> {
    return this.httpClient.delete<any>(`${URLS.CONTENT_COLLECTION}/${workflowId}`);
  }

  public updateWorkflowName(content_collection_id: string, name: string): Observable<any> {
    return this.httpClient.post<any>(`${URLS.FLOW}/execution/rename_contract`, { content_collection_id, name });
  }

  // Content Collection methods for prompt testing
  getContentCollections(): Observable<any[]> {
    return this.httpClient.get<any>(`${URLS.SUBSCRIPTION}`).pipe(
      map((response: any) => {
        // Extract contentCollection array from subscription data
        const allCollections = response.contentCollection || [];
        
        // Filter for prompt_execution content collections
        const promptExecutionCollections = allCollections.filter((collection: any) => 
          collection.contentCollectionType === 'prompt_execution'
        );
        
        return promptExecutionCollections;
      })
    );
  }

  createContentCollection(data: { name: string; description: string }): Observable<any> {
    return this.httpClient.post<any>(`${URLS.CONTENT_COLLECTION}/prompt_execution`, data);
  }
}
